import React from 'react';
import GNdaFilesTable from '../../tables/GNdaFilesTable';
import { useDbUser } from '../../utils/contexts/UserContext';

export default function NDATab() {
    const { dbUser } = useDbUser();
    const userId = dbUser?.id ?? dbUser?.user_id ?? null;

    return (
        <div className='standard-div'>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div className='standard-div-flex'>
                    <h1>NDA Files</h1>
                </div>
                <div style={{ width: '100%' }}>
                    <GNdaFilesTable userId={userId} />
                </div>
            </div>
        </div>
    );
}
